var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppSelector } from "../../../../hooks/customReduxHooks";
var IndicadorHotSale = function (_a) {
    var activo = _a.activo, desactivarContador = _a.desactivarContador;
    var globalConfig = useAppSelector(function (state) { return state.empresa && state.empresa.globalConfig; });
    return (React.createElement(React.Fragment, null, activo && desactivarContador && (React.createElement(StyledIndicador, null,
        React.createElement(FontAwesomeIcon, { icon: globalConfig.hotSale.iconoHotSale })))));
};
var StyledIndicador = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  svg {\n    color: ", ";\n    position: absolute;\n    z-index: 1;\n    top: 0;\n    left: 0;\n    padding: 10px;\n    border-bottom: 0;\n  }\n"], ["\n  svg {\n    color: ", ";\n    position: absolute;\n    z-index: 1;\n    top: 0;\n    left: 0;\n    padding: 10px;\n    border-bottom: 0;\n  }\n"])), function (props) { return props.theme.hotSaleColor; });
export default IndicadorHotSale;
var templateObject_1;
